var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',_vm._l((_vm.elements),function(element,i){return _c(element.type,{key:'element-' + i,tag:"component",attrs:{"index-element":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }